import { render, staticRenderFns } from "./MypageDetailsSettingSection.vue?vue&type=template&id=dd53ec2a&scoped=true"
import script from "./MypageDetailsSettingSection.vue?vue&type=script&lang=ts"
export * from "./MypageDetailsSettingSection.vue?vue&type=script&lang=ts"
import style0 from "./MypageDetailsSettingSection.vue?vue&type=style&index=0&id=dd53ec2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd53ec2a",
  null
  
)

export default component.exports